import React from 'react'

const RosteringIcon = (
  <>
    <path
      d="M15.3913 3.2168H2.6087C2.44726 3.2168 2.29244 3.28093 2.17828 3.39508C2.06413 3.50923 2 3.66406 2 3.82549V15.3907C2 15.5521 2.06413 15.707 2.17828 15.8211C2.29244 15.9353 2.44726 15.9994 2.6087 15.9994H15.3913C15.5527 15.9994 15.7076 15.9353 15.8217 15.8211C15.9359 15.707 16 15.5521 16 15.3907V3.82549C16 3.66406 15.9359 3.50923 15.8217 3.39508C15.7076 3.28093 15.5527 3.2168 15.3913 3.2168Z"
      fill="#E6E6E6"
    />
    <path
      d="M9.00005 13.87C9.04014 13.8701 9.07984 13.8622 9.11687 13.8468C9.1539 13.8315 9.18753 13.8089 9.21584 13.7805L11.5176 11.4705C11.8524 11.1352 12.0415 10.6814 12.044 10.2076C12.0466 9.73374 11.8623 9.27798 11.5312 8.93904C11.2001 8.6001 10.7487 8.40527 10.2749 8.39677C9.80117 8.38828 9.34313 8.56678 9.00005 8.89363C8.65695 8.56676 8.19887 8.38826 7.72506 8.39679C7.25126 8.40532 6.7999 8.6002 6.46878 8.9392C6.13766 9.2782 5.95346 9.73403 5.95608 10.2079C5.95871 10.6818 6.14794 11.1355 6.48279 11.4708L8.78427 13.7808C8.8126 13.8092 8.84624 13.8316 8.88327 13.8469C8.9203 13.8623 8.95999 13.8701 9.00005 13.87Z"
      fill="#E86C60"
    />
    <path
      d="M2.6087 3.2168H15.3913C15.5527 3.2168 15.7076 3.28093 15.8217 3.39508C15.9359 3.50923 16 3.66406 16 3.82549V6.26027H2V3.82549C2 3.66406 2.06413 3.50923 2.17828 3.39508C2.29244 3.28093 2.44726 3.2168 2.6087 3.2168Z"
      fill="#E86C60"
    />
    <path
      d="M13.2608 4.73913V2.30435C13.2608 2.22363 13.2288 2.14622 13.1717 2.08914C13.1146 2.03207 13.0372 2 12.9565 2H12.3478C12.2671 2 12.1897 2.03207 12.1326 2.08914C12.0755 2.14622 12.0435 2.22363 12.0435 2.30435V4.73913C12.0435 4.81985 12.0755 4.89726 12.1326 4.95434C12.1897 5.01141 12.2671 5.04348 12.3478 5.04348H12.9565C13.0372 5.04348 13.1146 5.01141 13.1717 4.95434C13.2288 4.89726 13.2608 4.81985 13.2608 4.73913Z"
      fill="#444444"
    />
    <path
      d="M5.95653 4.73913V2.30435C5.95653 2.22363 5.92446 2.14622 5.86739 2.08914C5.81031 2.03207 5.7329 2 5.65218 2H5.04348C4.96277 2 4.88535 2.03207 4.82828 2.08914C4.7712 2.14622 4.73914 2.22363 4.73914 2.30435V4.73913C4.73914 4.81985 4.7712 4.89726 4.82828 4.95434C4.88535 5.01141 4.96277 5.04348 5.04348 5.04348H5.65218C5.7329 5.04348 5.81031 5.01141 5.86739 4.95434C5.92446 4.89726 5.95653 4.81985 5.95653 4.73913Z"
      fill="#444444"
    />
  </>
)

export default RosteringIcon
